"use strict";

/*global require, module*/
const Tabs = require("./dist/js/Tabs");

const constructAll = function constructAll() {
  Tabs.init();
  document.removeEventListener('o.DOMContentLoaded', constructAll);
};

document.addEventListener('o.DOMContentLoaded', constructAll);
module.exports = Tabs;